import { useCallback, useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { getSubmit, scrollToComponent } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { adminSkuRowViewedMappings, isLoadingAdminSkuViewMapping } from "../@signals"


export default function useAdminSkuViewMapping() {
    const data = useSignal([])

    useEffect(() => {
        if (adminSkuRowViewedMappings.value.skuID)
            handleSubmit()
        else data.value = []
    }, [adminSkuRowViewedMappings.value.skuID])

    const handleSubmit = () => {
        isLoadingAdminSkuViewMapping.value = true
        getSubmit(`${BACKEND_APIS.ADMIN}/sku/view-mappings/${adminSkuRowViewedMappings.value.skuID}`).then(res => {
            isLoadingAdminSkuViewMapping.value = false
            data.value = res.data
            setTimeout(() => {
                scrollToComponent("product-mapping")
            }, 1)
        }).catch(() => {
            isLoadingAdminSkuViewMapping.value = false
            data.value = []
            adminSkuRowViewedMappings.value = {}
        })
    }

    const handleClose = useCallback(() => {
        adminSkuRowViewedMappings.value = {}
        data.value = []
    }, [])

    return {
        data: data.value,
        isLoading: isLoadingAdminSkuViewMapping.value,
        skuName: adminSkuRowViewedMappings.value.skuName,

        handleClose
    }
}